export default {
  message: {
    "error": "Une erreur est survenue !",
    "Sorrysomeerrorsoccurred": "Désolé, des erreurs sont survenues",
    "quit": "Quitter",
    "language": "Langue",
    "Youcanchangethelanguagehere": "Vous pouvez changer la langue ici !",
    "current": "Actuel",
    "home": "Accueil",
    "friends": "Amis",
    "wallet": "Portefeuille",
    "aboutus": "À propos de nous",
    "Sharewithfriends": "Partager avec des amis",
    "copyFailure": "Échec de la copie",
    "copySuccess": "Copie réussie",
    "Claimreward": "Recevoir la récompense",
    "DailyLogin": "Connexion quotidienne",
    "noInvitationsYet": "Aucune invitation pour l'instant",
    "LoadMore": "Charger plus",
    "WatchAD": "Regarder la publicité",
    "continue": "Continuer",
    "Congratulations": "Félicitations",
    "MyFriends": "Mes amis",
    "Invitefriends": "Inviter des amis",
    "Invitepremiumfriends": "Inviter des amis premium",
    "DailyTasks": "Tâches quotidiennes",
    "inviteDesc": "+{num} ${name} pour chaque ami que vous invitez",
    "DailyTasksDesc": "Complétez des tâches pour obtenir plus de ${name}",
    "SponsorsandPartners": "Partenaires et sponsors",
    "Receivingwallet": "Portefeuille de réception",
    "Enterwalletaddress": "Entrer l'adresse du portefeuille {name}",
    "Claim": "Recevoir",
    "Booster": "Accélérateur",
    "RentPeriod": "Période de location",
    "days30": "30 jours",
    "days": "jours",
    "Dailyprofit": "Bénéfice quotidien",
    "Totalprofit": "Bénéfice total",
    "Quantity": "Quantité",
    "RentPrice": "Prix de location",
    "RentMiner": "Louer un mineur",
    "Insufficient": "Insuffisant ${name}",
    "InsufficientMsg": "{num} ${name1} nécessaires, invitez des amis ou complétez des tâches pour gagner plus de ${name2}.",
    "Settings": "Paramètres",
    "copyid": "Copier l'ID",
    "UpgradeSuccessfully": "Mis à niveau avec succès",
    "Name": "Nom",
    "userinfo": "Informations utilisateur",
    "disconnect": "Déconnexion",
    "Startmining": "Commencer à miner",
    "Welcome": "Bienvenue à {name}",
    "Withdrawal": "Retrait",
    "Minimumamount": "Montant minimum",
    "Networkfee": "Frais de réseau",
    "Enteramount": "Entrer le montant",
    "Submit": "Soumettre",
    "MinimumTip": "Le montant du retrait est trop petit. Montant minimum de retrait : {num}",
    "MaximumTip": "Montant insuffisant, le montant maximum que vous pouvez retirer est : {num}",
    "SubmittedTip": "Soumis, traitement attendu dans les 30 à 60 jours ouvrables",
    "WithdrawStatus": "Statut",
    "Submissiontime": "Temps de soumission",
    "WithdrawAwaitTip": "* Il est estimé que cela prendra 30 à 60 jours ouvrables. Inviter plus d'amis peut accélérer le processus de révision.",
    "Processing": "Traitement",
    "Amount": "Montant",
    "Numberoffriends": "Nombre d'amis : {now}/{limit}",
    "InviteTip": "Pour effectuer votre premier retrait, vous devez inviter {limit} amis à rejoindre l'application de minage.",
    "openonphone": "Ouvrez ce lien sur votre téléphone.",
    "claimTip": "Le montant à collecter est trop petit. Le montant minimum à collecter est : {num}",
    "WalletBalance": "Solde du portefeuille",
    "Withdraw": "Retirer",
    "SetWalletAddress": "Définir l'adresse du portefeuille",
    "WithdrawalRecord": "Historique des retraits",
    "Norecords": "Aucun enregistrement",
    "Whatis": "Qu'est-ce que {name} ?",
    "All": "Tous",
    "save": "Enregistrer",
    "successWithdrawal": "Le retrait a été reçu {num}",
    "secondsago": "{time} secondes auparavant",
    "Loading": "Chargement...",
    "PaymentConfirming": "Vérification de l'état de la transaction...",
    "Check": "Vérifier",
    "CheckFail": "Transaction non terminée. Veuillez vérifier à nouveau dans 5 secondes.",
    "Addname": "Ajouter '{name}' à votre nom",
    "Restattcheck": "Redémarrez l'application pour vérifier",
    "Copyname": "Copier '{name}'",
    "SubmissionFailed": "Échec de la soumission, veuillez réessayer plus tard",
    "WithdrawalReview": "Révision du retrait",
    "WebWithdrawAwaitTip": "* Il est estimé que cela prendra 24 à 48 heures. Inviter plus d'amis peut accélérer le processus de révision.",
    "Success": "Succès",
    "Rejection": "Rejet",
    "WebSubmittedTip": "Soumis, traitement attendu dans les 24 à 48 heures",
    "shop": "Boutique",
    "topurchase": "Allez à la boutique pour acheter",
    "shopDesc": "Disponibilité limitée - obtenez le vôtre avant qu'il ne disparaisse !",
    "claim": "Collecter",
    "payment_success": "Paiement réussi",
    "payment_failed": "Paiement échoué",
    "payment_cancelled": "Paiement annulé",
    "opening_payment": "Ouverture du paiement...",
    "payment_status": "Statut du paiement",
    "create_order_failed": "Échec de la création de la commande",
    "creating_ton_order": "Création de la commande TON...",
    "next_step": "Prochaine étape",
    "use_ton_payment": "Utiliser le paiement TON",
    "start_transaction": "Commencer la transaction",
    "connect_wallet": "Connecter le portefeuille",
    "address": "Adresse",
    "amount_ton": "Montant TON",
    "copy": "Copier",
    "amount": "Montant",
    "wallet_address": "Adresse du portefeuille",
    "comment_memo": "Memo commentaire",
    "you_can_choose_to_connect_wallet_to_pay": "Vous pouvez choisir de connecter le portefeuille pour payer",
    "or_manually_transfer_to_the_above_address": "Ou transférer manuellement à l'adresse ci-dessus (notez que le montant et le mémo doivent être exactement les mêmes)",
    "transaction_success": "Transaction réussie",
    "transaction_failed": "Échec de la transaction",
    "transaction_error": "Erreur de transaction",
    "transaction_status": "Statut de la transaction",
    "transaction_id": "ID de la transaction",
    "transaction_amount": "Montant de la transaction",
    "transaction_status_desc": "Description du statut de la transaction",
    "payment_status_tip": "Veuillez attendre que le paiement soit confirmé",
    "select_payment_method": "Sélectionner le mode de paiement",
    "total_amount": "Montant total",
    "creating_order": "Création de la commande...",
    "order_created": "Commande créée",
    "order_status": "État de la commande",
    "Applyforwithdrawal": "Demander un retrait",
    "Withdrawalunlock": "Déverrouillage du retrait",
    "WithdrawalunlockTip": "Vous avez besoin de {num} amis invités pour compléter des tâches/lier des portefeuilles afin de déverrouiller le retrait",
    "Close": "Fermer",
    "Delivering": "En cours de livraison",
    "Duetothelargenumber": "En raison du grand nombre de destinataires, votre airdrop devrait arriver dans 15 à 20 jours ouvrables",
    "select_network": "Sélectionner le réseau",
    "confirm": "confirmer",
    "switching_network": "Changement de réseau...",
    "network_switched": "Réseau changé",
    "use_usdt_payment": "Utiliser le paiement USDT",
    "or_manually_transfer_to_the_above_address_usdt": "Transférez manuellement à l'adresse ci-dessus (notez que le montant et l'adresse doivent être exactement les mêmes)",
    "chain_type": "Réseau",
    "check_transaction_status": "Vérifiez l'état de la transaction",
    "transaction_wait": "La transaction est en cours de traitement. Vous pouvez quitter l'application. Un message vous notifiera une fois qu'elle est terminée.",
    "twa_pay_tip_with_memo": "Veuillez vous assurer que l'adresse, le montant et le mémo sont cohérents pour le transfert.",
    "twa_pay_tip": "Veuillez vous assurer que l'adresse et le montant sont corrects pour le transfert.",
    "creating_usdt_order": "Création de la commande USDT...",
    "affiliate_programs": "Programmes d'affiliation",
    "affiliate_programs_description": "Invitez des amis à rejoindre l'application de minage et gagnez des récompenses.",
    "commission_details": "Détails de la commission",
    "no_commission_records": "Aucun enregistrement de commission",
    "commission_list": "Liste des commissions",
    "input_amount": "Montant à entrer",
    "max": "Max",
    "commission_input_amount": "Montant de la commission à entrer",
    "min_commission": "Le montant minimum de retrait est {num}",
    "WithdrawalSuccess": "Retrait réussi",
    "WithdrawalFailed": "Échec du retrait",
    "WithdrawalProcessing": "Retrait en cours",
    "award": "Récompense",
    "level": "Niveau",
    "Share_to_group": "Partager au groupe",
    "Exchange": "Échanger",
    "balance_not_enough": "Solde insuffisant, vous ne pouvez échanger que {num} {coin}",
    "exchange_fail": "Échange échoué",
    "exchange_success": "Échange réussi",
    "you_will_receive": "Vous recevrez",
    "ShareToGroups": "Partager dans des groupes",
    "Numberofgroups": "Nombre de groupes : {now}/{limit}",
    "Confirm": "Confirmer",
    "ShareToGroupsDesc": "Partager dans des groupes pour obtenir plus de {name}",
    "TokenAddress": "Veuillez entrer les détails du retrait tels que l'ID d'échange ou l'adresse USDT",
    "CashAddress": "Veuillez entrer les détails du retrait tels que le numéro de carte bancaire ou l'adresse USDT",
    "Cancel": "Annuler",
    "min_withdrawal_amount": "Le montant minimum de retrait est {num} {coin}",
    "max_withdrawal_amount": "Le montant maximum de retrait est {num} {coin}",
    "withdrawal_failed": "Échec du retrait",
    "withdrawal_success": "Retrait réussi",
    "PayNow": "Payer maintenant",
    "PaySkip": "Payer {num} pour débloquer instantanément le retrait",
    "NumberofGroups": "Nombre de groupes : {now}/{limit}",
    "SendMessage": "Envoyer un message",
    "NumberofShares": "Nombre de partages : {now}/{limit}",
    "NumberofTasks": "Nombre de tâches : {now}/{limit}",
    "CompleteTask": "Compléter la tâche",
    "PleaseEnterValidAmount": "Veuillez entrer un montant valide",
    "PleaseEnterValidEmail": "Veuillez entrer une adresse e-mail valide",
    "Feedback": "Retour d'information",
    "Inputfeedbackcontent": "Entrez le contenu du retour d'information",
    "Submitfeedback": "Soumettre le retour d'information",
    "Pleaseenteravalidemailaddress": "Veuillez entrer une adresse e-mail valide",
    "Pleaseenteryouremailaddress": "Veuillez entrer votre adresse e-mail",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Vous avez déjà donné votre retour aujourd'hui, veuillez revenir demain",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Retour d'information soumis avec succès, merci pour vos précieux retours",
    "Feedback_submission_failed_please_retry": "Échec de la soumission du retour d'information, veuillez réessayer",
    "ContactUs": "Contactez-nous",
    "XRPAddress": "Veuillez remplir l'adresse du portefeuille XRP activé (y compris le MEMO), sinon vous ne pourrez pas retirer de fonds.",
    "Accelerated": "Accéléré",
    "Accelerated_withdrawals_success": "Retraites accélérées réussies",
    "login": "Connexion",
    "register": "S'inscrire",
    "login_with_google": "Connexion avec Google",
    "or": "OU",
    "email": "Email",
    "password": "Mot de passe",
    "no_account": "Vous n'avez pas de compte",
    "click_to_go": "Cliquez pour",
    "have_account": "Vous avez déjà un compte",
    "go_to": "Aller à",
    "invite_code": "Code d'invitation",
    "optional": "Optionnel",
    "google_login_not_ready": "La connexion Google n'est pas prête, veuillez réessayer plus tard",
    "password_too_long": "Le mot de passe est trop long",
    "weak": "Faible",
    "medium": "Moyen",
    "strong": "Fort",
    "login_success": "Connexion réussie",
    "login_failed": "Échec de la connexion",
    "please_input_email": "Veuillez entrer votre email",
    "invalid_email": "Format d'email invalide",
    "please_input_password": "Veuillez entrer votre mot de passe",
    "password_length_6_to_16": "Le mot de passe doit comporter entre 6 et 16 caractères",
    "account_or_password_error": "Erreur de compte ou de mot de passe",
    "register_success": "Inscription réussie",
    "register_failed": "Échec de l'inscription",
    "save_error": "Erreur de sauvegarde, veuillez réessayer plus tard",
    "ShareToFriends": "Partager avec des amis",
    "login_first": "Veuillez d'abord vous connecter",
    "WalletBscError": "❌ Adresse de portefeuille BNB Chain invalide.",
    "DownloadWallet": "Télécharger le Portefeuille",
    "AddToHomeScreen": "Ajouter {appName} à l'écran d'accueil",
    "TapShareInToolbar": "Appuyez dans la barre d'outils",
    "SelectAddToHomeScreen": "Sélectionnez ajouter à l'écran d'accueil",
    "OpenToolbar": "Ouvrir la barre d'outils",
    "ClaimFailed": "Échec de la collecte, veuillez réessayer plus tard",
    "guest_login": "Connexion Invité",
    "please_input_phone": "Veuillez entrer votre numéro de téléphone",
    "email_error_1": "Veuillez entrer votre email",
    "email_error_2": "Veuillez entrer une adresse email valide",
    "email_error_3": "Les emails invités ne sont pas autorisés, veuillez utiliser un vrai email",
    "phone": "Téléphone",
    "phone_error_1": "Veuillez entrer votre numéro de téléphone",
    "phone_error_2": "Veuillez entrer un numéro de téléphone valide",
    "update_info": "Mettre à jour les informations",
    "update_success": "Mise à jour réussie",
    "update_failed": "Échec de la mise à jour, veuillez réessayer plus tard",
    "cancel": "Annuler",
    "guest_credentials_title": "Informations sur le compte",
    "guest_credentials_warning": "Veuillez faire une capture d'écran pour enregistrer votre compte et votre mot de passe. En cas de perte, vos gains ne peuvent pas être récupérés !",
    "i_have_saved": "J'ai enregistré",
    "account": "Compte",
    "view_credentials": "Voir les informations d'identification",
    "miner_max_reached": "Vous avez atteint le nombre maximal de ce mineur"
}};